(() => {
  if (!window.MOX_DRAFT || !window.MOX_CUSTOMER_ID) return;
  window.bootDraftRefresh?.();

  const getRow = (el) => el.closest('[data-cart-item]');
  const getVid = (row) => row?.getAttribute('data-variant-id');
  const getQty = (row) => row?.querySelector('.qty-input');

  const bumpDraft = async (variantId, delta) => {
    if (!variantId || !delta) return;
    try {
      await window.MOX_DRAFT.addItem(variantId, delta); // delta: +1, -1, etc.
      window.bootDraftRefresh?.();
      document.dispatchEvent(new CustomEvent('mox:draft:changed', { detail: { variantId, delta } }));
    } catch (err) {
      console.error('[mox-draft-cart] Error actualizando draft:', err);
    }
  };

  // Botones +/-
  document.addEventListener('click', (e) => {
    const plus = e.target.closest('[data-qty-plus]');
    const minus = e.target.closest('[data-qty-minus]');
    if (!plus && !minus) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    const row = getRow(plus || minus);
    const vid = getVid(row);
    const delta = plus ? +1 : -1;

    const input = getQty(row);
    if (input) {
      const prev = Number(input.value || 0);
      const next = Math.max(0, prev + delta);
      input.value = String(next);
      input.setAttribute('data-prev', String(next));
    }

    bumpDraft(vid, delta);
  });

  // Cambio manual en el input
  document.addEventListener('change', (e) => {
    const input = e.target.closest?.('.qty-input');
    if (!input) return;
    e.stopImmediatePropagation();

    const row = getRow(input);
    const vid = getVid(row);
    const prev = Number(input.getAttribute('data-prev') ?? input.defaultValue ?? input.value ?? 0);
    const next = Math.max(0, Number(input.value || 0));

    input.value = String(next);
    input.setAttribute('data-prev', String(next));

    const delta = next - prev;
    if (delta !== 0) bumpDraft(vid, delta);
  });

  // Valor base para calcular deltas correctos
  document.querySelectorAll('[data-cart-item] .qty-input').forEach((input) => {
    if (!input.hasAttribute('data-prev')) {
      input.setAttribute('data-prev', String(input.value || 0));
    }
  });
})();
